import { getColorVariable } from "@components/common/utils/helper";
import { type OptionProps } from "./option";
import { KeyValueObject } from "@components/common/types/general";

export function getColor(color: OptionProps["color"], theme: any): KeyValueObject {
    return {
        color: getColorVariable(color, theme, {
            gray: theme.colors.gray[400],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[950],
        }),
    };
}

export function getBackgroundColor(active: OptionProps["active"], theme: any): KeyValueObject | null {
    if (active) {
        return { backgroundColor: theme.colors.gray[50] };
    }
    return null;
}

export function getSpinnerBorderColor(color: OptionProps["color"], theme: any): KeyValueObject {
    return {
        borderColor: `${getColorVariable(color, theme, {
            gray: theme.colors.gray[400],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[950],
        })} ${getColorVariable(color, theme, {
            gray: theme.colors.gray[400],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[950],
        })} ${getColorVariable(color, theme, {
            gray: theme.colors.gray[400],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[950],
        })} transparent;`,
    };
}

export function getAdornmentsSvgColor(color: OptionProps["color"], theme: any): KeyValueObject {
    return {
        color: getColorVariable(color, theme, {
            gray: theme.colors.gray[400],
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.gray[500],
        }),
    };
}

export function getPadding(size: OptionProps["size"], theme: any): KeyValueObject {
    if (size === "sm") {
        return {
            paddingLeft: theme.spacing[2],
            paddingRight: theme.spacing[2],
            paddingTop: theme.spacing.px,
            paddingBottom: theme.spacing.px,
        };
    }
    if (size === "lg") {
        return {
            paddingLeft: theme.spacing[2],
            paddingRight: theme.spacing[2],
            paddingTop: "5px",
            paddingBottom: "5px",
            [`@media (min-width: ${theme.screens.lg})`]: {
                paddingLeft: theme.spacing[3],
                paddingRight: theme.spacing[3],
                paddingTop: theme.spacing[2],
                paddingBottom: theme.spacing[2],
            },
        };
    }
    return {
        paddingLeft: theme.spacing[2],
        paddingRight: theme.spacing[2],
        paddingTop: "5px",
        paddingBottom: "5px",
    };
}

export function getBorderRadius(rounded: OptionProps["rounded"], theme: any): KeyValueObject | null {
    if (rounded === "md") {
        return {
            borderRadius: theme.borderRadius.DEFAULT,
        };
    }
    if (rounded === "lg") {
        return {
            borderRadius: theme.borderRadius.lg,
        };
    }
    if (rounded === "full") {
        return {
            borderRadius: theme.borderRadius.full,
        };
    }
    return null;
}

export function getDividerBackground(dividerType: OptionProps["dividerType"], theme: any): KeyValueObject {
    if (dividerType === "dashed") {
        return {
            backgroundImage: `linear-gradient(90deg, ${theme.colors.gray[200]} 50%, transparent 50%), 
                              linear-gradient(0deg, ${theme.colors.gray[200]} 50%, transparent 50%)`,
            backgroundSize: "10px 2px, 2px 10px",
            backgroundRepeat: "repeat",
        };
    }
    if (dividerType === "dotted") {
        return {
            backgroundImage: `radial-gradient(${theme.colors.gray[200]} 10%, transparent 10%)`,
            backgroundSize: "10px 10px",
            backgroundRepeat: "repeat",
        };
    }
    return {
        backgroundColor: theme.colors.gray[200],
    };
}
